export function buildPositionElementId(id: string) {
    return `position-${id}`;
}
